import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Drawer.css';

export const Drawer = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const [level, setLevel] = useState()

  useEffect(() => {
    const level_id = localStorage.getItem("fpaccessLevel");
    setLevel(level_id)
  }, []);

  const handleLogout = () => {
    // Remover todos os dados do localStorage relacionados ao usuário
    localStorage.removeItem("fpid");
    localStorage.removeItem("fpemail");
    localStorage.removeItem("fpfirstName");
    localStorage.removeItem("fplastName");
    localStorage.removeItem("fptoken");

    // Fechar o menu e redirecionar para login
    setOpen(false);
    navigate("/login");
  };

  return (
    <>
      {open && <div className="overlay" onClick={() => setOpen(false)}></div>}

      <div className={`drawer ${open ? 'open' : ''}`}>

        <div className="drawer-header">

          <h2 className="drawer-title">
            Menu
          </h2>

          <button
            className="close-btn"
            onClick={() => setOpen(false)}
          >
            ×
          </button>

        </div>
        <ul>
          <li className='btn-link'><Link to="/Home" onClick={() => setOpen(false)}>Inicio</Link></li>
          <li className='btn-link'><Link to="/clients" onClick={() => setOpen(false)}>Clientes</Link></li>
          <li className='btn-link'><Link to="/contacts" onClick={() => setOpen(false)}>Contatos</Link></li>
          {Number(level) === 0 &&
            <li className='btn-link'><Link to="/brandsmodels" onClick={() => setOpen(false)}>Marcas & Modelos</Link></li>
          }
          <li className='btn-link'><Link to="/orders" onClick={() => setOpen(false)}>Ordens</Link></li>
          <li className='btn-link'><Link to="/vehicles" onClick={() => setOpen(false)}>Veículos</Link></li>
          <li className='btn-link'><Link to="/clients" onClick={() => setOpen(false)}>Ordens Finalizadas</Link></li>
        </ul>

        {/* Botão de Logout */}
        <div className="logout-container">
          <button className="logout-btn" onClick={handleLogout}>Sair</button>
        </div>
      </div>
    </>
  );
}
